import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";

import MainLayout from "../../../../components/layout/MainLayout";
import Breadcrumbs from "../../../../components/common/Breadcrumbs";
import SafetyPlanUrduForm from "./SafetyPlanUrduForm";

import { createSafetyPlanUrdu } from "../../../../store/slices/safetyPlansUrduSlice";

// Helper to convert camelCase to snake_case
const toSnakeCase = (obj) => {
    const result = {};
    for (const key in obj) {
        const snakeKey = key.replace(/[A-Z]/g, (letter) => `_${letter.toLowerCase()}`);
        result[snakeKey] = obj[key];
    }
    return result;
};

const AddSafetyPlanUrdu = () => {
    const navigate = useNavigate();
    const { state } = useLocation();
    const { caseId, patientId } = state || {};

    const dispatch = useDispatch();

    const [formData, setFormData] = useState({
        caseId: state?.caseId || null,
        patientId: state?.patientId || null,
        warningSigns: "",
        internalCoping: "",
        socialDistractions: "",
        peopleForHelp: "",
        professionals: "",
        safeEnvironment: "",
        reasonsForLiving: "",
        additionalNotes: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Convert formData to snake_case before sending to backend
        const payload = toSnakeCase({
            ...formData,
            caseId,
            patientId
        });

        try {
            const res = await dispatch(createSafetyPlanUrdu(payload)).unwrap();

            Swal.fire("Saved!", "Safety Plan (Urdu) has been successfully saved.", "success");
            navigate(`/residential/optional/safety-plan-urdu/edit/${res.id || res.data?.id || (res && res[0]?.id)}`, { state: { patientId: patientId || (res && res.patient_id), caseId: caseId || (res && res.case_id) } });
        } catch (err) {
            Swal.fire("Error", err || "Failed to save Safety Plan (Urdu).", "error");
        }
    };

    return (
        <MainLayout>
            <div className="container-xxl flex-grow-1 container-p-y">
                <Breadcrumbs />
                <div className="card">
                    <h5 className="card-header text-center fw-bold">Safety Plan (Urdu)</h5>
                    <div className="card-body">
                        <form onSubmit={handleSubmit}>
                            <SafetyPlanUrduForm formData={formData} handleChange={handleChange} />
                            <div className="col-12 d-flex justify-content-end mt-3">
                                <div className="col-md-2 d-flex justify-content-end">
                                    <button type="submit" className="btn btn-primary px-4">
                                        <i className="ri-save-2-line me-1"></i> Save
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default AddSafetyPlanUrdu;
